import styles from "./ConsultationCost.module.scss";
import { Link } from "react-router-dom";

export const ConsultationCost = () => {
    return (
        <div className={styles.consultationCost}>
            <div className={styles.consultationCostWrapper}>
                <div className={styles.costTitle}>
                    <div className={styles.title}>Consultation costs:</div>
                    <div className={styles.cost}>from $1,190</div>
                </div>
                <div className={styles.conduct}>
                    In 2025, Dr. Torsunov will conduct personal consultations,
                    the funds from which he will direct to the creation of
                    spiritual and educational projects and the popularization of
                    healthy lifestyle methods throughout the world.
                </div>
            </div>
            <div className={styles.buttonBlock}>
                <div className={styles.buttonWrapper}>
                    <button className={styles.buttonSign}>
                        SIGN UP FOR A CONSULTATION
                    </button>
                    <button className={styles.buttonQuestion}>
                        ASK A QUESTION ON TELEGRAM
                    </button>
                </div>
                <div className={styles.link}>
                    <Link
                        to={"https://forms.gle/5toEbdGAqvgdQ3no8"}
                        target="_blank"
                    >
                        fill out the form
                    </Link>
                </div>
            </div>
        </div>
    );
};
